/**
 * The bell's three routes (P4-2, ADR-0078 §6). The reader's own, so no justification is sent: an
 * item holds only what was already sent to the facets it is routed to, and opening the Order or the
 * Merchant behind it goes through the screen that asks for one.
 */
import type { InboxMutesView, InboxView } from '@tard/contracts';
import { apiFetch } from './client.js';

export function getInbox(): Promise<{ readonly inbox: InboxView }> {
  return apiFetch('/me/inbox');
}

export function markInboxRead(itemId: string): Promise<{ readonly inbox: { readonly read: string } }> {
  return apiFetch(`/me/inbox/${encodeURIComponent(itemId)}/read`, { method: 'POST' });
}

export function markInboxAllRead(): Promise<{ readonly inbox: { readonly marked: number } }> {
  return apiFetch('/me/inbox/read-all', { method: 'POST' });
}

/**
 * A person's own mutes (P4-3c). Under `inbox` because what is muted is the bell; the screen that
 * shows them is `/me/notifications`, which is what a person calls their own notification settings.
 */
export function getInboxMutes(): Promise<{ readonly inbox: InboxMutesView }> {
  return apiFetch('/me/inbox/mutes');
}

export function muteNotice(typeKey: string): Promise<{ readonly inbox: { readonly muted: string } }> {
  return apiFetch(`/me/inbox/mutes/${encodeURIComponent(typeKey)}`, { method: 'POST' });
}

export function unmuteNotice(typeKey: string): Promise<{ readonly inbox: { readonly unmuted: string } }> {
  return apiFetch(`/me/inbox/mutes/${encodeURIComponent(typeKey)}`, { method: 'DELETE' });
}
